import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f1b18176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = {
  key: 1,
  class: "course-page details"
}
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "subtitle-line" }
const _hoisted_5 = { class: "tags-list" }
const _hoisted_6 = { class: "page-content" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-section-title" }, "Program Description", -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-section-title" }, "Target Audience", -1))
const _hoisted_13 = { class: "audiences-list" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-section-title" }, "Educational Objectives", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upon completion of this activity, the learner should be able to:", -1))
const _hoisted_17 = { class: "objectives-list" }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-section-title" }, "Commercial Supporter", -1))
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 4 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-section-title" }, "Provider", -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "tab-section-title" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  id: "speakers",
  ref: "speakersRef"
}
const _hoisted_27 = { class: "speakers-item" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { class: "text-m-bold" }
const _hoisted_30 = { class: "speakers-item-roles" }
const _hoisted_31 = {
  key: 0,
  class: "speakers-item-location"
}
const _hoisted_32 = {
  key: 1,
  class: "speakers-item-information"
}
const _hoisted_33 = {
  key: 2,
  class: "speakers-item-disclosure"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "tab-section-title" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "tab-section-title" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "course-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.fetching)
      ? (_openBlock(), _createBlock($setup["AppLoader"], { key: 0 }))
      : ($setup.coursePreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              class: "button button-back",
              to: { name: $setup.coursePreview?.learning_center_id ? $setup.routesName.center : $setup.routesName.coursesList, params: { id: $setup.coursePreview?.learning_center_id }, query: { inReview: $setup.coursePreview?.status === $setup.CourseStatusEnum.inReview ? 'true' : undefined } }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.coursePreview?.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tags-item",
                    key: tag.id
                  }, _toDisplayString(tag.name), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                ($setup.coursePreview?.poster)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "poster",
                      src: $setup.coursePreview?.poster?.url,
                      alt: $setup.coursePreview?.title
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createVNode($setup["CourseTabs"], {
                  modelValue: $setup.activeTab,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.activeTab) = $event)),
                  tabs: $setup.availableTabs
                }, {
                  "tab-1": _withCtx(() => [
                    ($setup.coursePreview?.overview.description)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("div", {
                            class: "html-section",
                            innerHTML: $setup.coursePreview?.overview.description
                          }, null, 8, _hoisted_10)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.coursePreview?.audiences?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("p", null, _toDisplayString($setup.coursePreview?.activity_designed_for), 1),
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coursePreview?.audiences, (audience) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "audiences-item",
                                key: audience.id
                              }, _toDisplayString(audience.name), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.coursePreview?.overview.educational_objectives?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                          _hoisted_15,
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coursePreview?.overview.educational_objectives, (obj, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "objectives-item",
                                key: index
                              }, _toDisplayString(obj), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.coursePreview?.overview.commercial_supporter)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", {
                            class: "html-section",
                            innerHTML: $setup.coursePreview?.overview.commercial_supporter
                          }, null, 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.coursePreview?.overview.commercial_provider)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", {
                            class: "html-section",
                            innerHTML: $setup.coursePreview?.overview.commercial_provider
                          }, null, 8, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  "tab-2": _withCtx(() => [
                    ($setup.coursePreview?.information?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.coursePreview?.information, (instruction, index) => {
                          return (_openBlock(), _createElementBlock("section", { key: index }, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(instruction.title), 1),
                            _createElementVNode("div", {
                              class: "html-section",
                              innerHTML: instruction.description
                            }, null, 8, _hoisted_25)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]),
                  "tab-3": _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedSpeakers, (speaker) => {
                        return (_openBlock(), _createElementBlock("section", {
                          key: speaker.id
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", null, [
                              (speaker.avatar)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "speakers-item-avatar",
                                    src: speaker.avatar?.url,
                                    alt: speaker.name
                                  }, null, 8, _hoisted_28))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(speaker.name) + " " + _toDisplayString(speaker.degree), 1),
                              _createElementVNode("div", _hoisted_30, _toDisplayString($setup.getSpeakerRoles(speaker.speaker_functions)), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speaker.lines, (line, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "speakers-item-qualification",
                                  key: index
                                }, _toDisplayString(line), 1))
                              }), 128)),
                              (speaker.location)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(speaker.location), 1))
                                : _createCommentVNode("", true),
                              (speaker.information)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createVNode($setup["CourseInformationSection"], {
                                      text: speaker.information
                                    }, null, 8, ["text"])
                                  ]))
                                : _createCommentVNode("", true),
                              (speaker.disclosure)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", {
                                      class: "text-m-medium html-section",
                                      innerHTML: speaker.disclosure
                                    }, null, 8, _hoisted_34)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128)),
                      ($setup.coursePreview?.general_info)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, _toDisplayString($setup.coursePreview?.general_info?.title), 1),
                            _createElementVNode("div", {
                              class: "html-section",
                              innerHTML: $setup.coursePreview?.general_info?.description
                            }, null, 8, _hoisted_37)
                          ]))
                        : _createCommentVNode("", true)
                    ], 512)
                  ]),
                  "tab-4": _withCtx(() => [
                    ($setup.coursePreview?.instructions?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.coursePreview?.instructions, (instruction, index) => {
                          return (_openBlock(), _createElementBlock("section", { key: index }, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(instruction.title), 1),
                            _createElementVNode("div", {
                              class: "html-section",
                              innerHTML: instruction.description
                            }, null, 8, _hoisted_39)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "tabs"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode($setup["CourseInfoPanel"], {
                  "preview-data": $setup.coursePreview,
                  "course-id": $setup.courseId
                }, null, 8, ["preview-data", "course-id"]),
                ($setup.activeTab !== 3 && $setup.coursePreview?.speakers?.length)
                  ? (_openBlock(), _createBlock($setup["CourseFacultyPanel"], {
                      key: 0,
                      "preview-data": $setup.coursePreview,
                      onOnReadMore: $setup.openFacultyTab
                    }, null, 8, ["preview-data"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}